"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/utils/noop.js
// module id = 9vKl
// module chunks = 46